import classes from './InputPair.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
}

const InputPair = ({ children }: Props) =>
  <div className={classes.InputPair}>
    {children}
  </div>

export default InputPair
